import format from "date-fns/format";
import isValid from "date-fns/isValid";
import isString from "lodash/isString";
import { isoToDate } from "./isoToDate";

export const formatDateShort = (d) => {
  let dateObject;

  if (isString(d)) {
    const isoConverted = isoToDate(d);
    dateObject = isoConverted;
  }

  if (!isValid(dateObject)) {
    console.warn("Date is not valid", dateObject);
    return;
  }

  return format(dateObject, "M/d/yyyy");
};
